import useApiMutation from '_api/mutations/useApiMutation';
import { Challenge, ChallengePayload } from '_api/types';

export const UPDATE_CHALLENGE_KEY = 'update-challenge-key';

export const useUpdateChallenge = () => {
  return useApiMutation<Challenge, ChallengePayload>(
    () => '/challenge',
    'put',
    {},
    {
      mutationKey: [UPDATE_CHALLENGE_KEY],
    },
  );
};
